import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { SextforceAutoRepost } from './useSextforceAutoRepost';

const useSextforceAutoRepostLogsStatsSummary = (autoRepost: SextforceAutoRepost) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const axios = useAxios();
    const dialog = useDialog();
    const params = useParams();

    // Fetch online users count vs. total sales report
    const fetchData = async (
        autoRepost: SextforceAutoRepost,
    ): Promise<{
        purchaseCount: number;
        purchaseSumm: number;
        tipCount: number;
        tipSum: number;
        lookCount: number;
        likeCount: number;
        commentCount: number;
        videoLookCount: number;
        videoPlayCount: number;
        videoPlayDuration: number;
        lookDuration: number;
    }> => {
        if (!userContext.jwtToken || !settingsContext.apiKey) {
            return {
                purchaseCount: 0,
                purchaseSumm: 0,
                tipCount: 0,
                tipSum: 0,
                lookCount: 0,
                likeCount: 0,
                commentCount: 0,
                videoLookCount: 0,
                videoPlayCount: 0,
                videoPlayDuration: 0,
                lookDuration: 0,
            };
        }

        const query: string = `${settingsContext.routes.autoRepost.base}${params.userId}/${autoRepost._id}/stats`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                handleHttpError(error, dialog);

                return {
                    purchaseCount: 0,
                    purchaseSumm: 0,
                    tipCount: 0,
                    tipSum: 0,
                    lookCount: 0,
                    likeCount: 0,
                    commentCount: 0,
                    videoLookCount: 0,
                    videoPlayCount: 0,
                    videoPlayDuration: 0,
                    lookDuration: 0,
                };
            });

        return data;
    };

    return useQuery(
        ['autoRepostLogsStatsSummary', params.userId, userContext.jwtToken, autoRepost._id],
        () => {
            return fetchData(autoRepost);
        },
        {
            refetchOnWindowFocus: false,
            enabled: userContext.jwtToken && params.userId && settingsContext.apiKey ? true : false,
        },
    );
};

export default useSextforceAutoRepostLogsStatsSummary;
